import {validateDecimal} from '../../../../utils/utils';

const validate = values => {
    const errors = {descripcion: '', cuota: '', estado: ''};
    if (!values.descripcion) {
        errors.descripcion = 'Agregue una descripción';
    }
    if (!values.cuota) {
        errors.cuota = 'Agregue una cuota';
    } else {
        if (!validateDecimal(values.cuota)) {
            errors.cuota = 'La cuota debe ser un valor numérico';
        }
    }

    if (!values.estado) {
        errors.estado = 'Escoja un estado';
    }
    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/components/pages/visicooler/modelos/validate.ts